export default "__VITE_ASSET__ZnCPvt1W__"